import React from 'react';
import { Box, Container } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Carga automática de todas las imágenes en assets/clubes
const clubImagesContext = require.context(
  '../../assets/clubes',
  false,
  /\.(png|jpe?g|svg|webp|gif)$/i
);

const clubImages = clubImagesContext.keys().sort().map((key) => clubImagesContext(key));

const ImageCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          width: '100%',
          height: '120px',
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          padding: '5px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '& .slick-dots': {
            bottom: '-10px',
          },
          '& .slick-dots li button:before': {
            fontSize: '8px',
          },
          '& .slick-track': {
            display: 'flex',
            alignItems: 'center',
          }
        }}
      >
        <Slider {...settings}>
          {clubImages.map((image, index) => (
            <Box
              key={index}
              sx={{
                height: '90px',
                width: '100%',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
                '& img': {
                  width: 'auto',
                  height: '80px',
                  objectFit: 'contain',
                  borderRadius: '8px',
                },
              }}
            >
              <img 
                src={image} 
                alt={`Club ${index + 1}`}
                onError={(e) => {
                  console.error(`Failed to load image: ${image}`);
                  e.target.style.display = 'none';
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>
    </Container>
  );
};

export default ImageCarousel;
